import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import * as types from 'modules/tags/actionTypes';
import { DASHBOARD_DEALER_SOURCE } from 'modules/tags/constants';

/** @typedef {import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer} TagsDashboardDealerReducer */

/**
 * @param {TagsDashboardDealerReducer} state
 * @param {DeleteTagSuccessAction} action
 */
const afterDeleteTagSuccess = (state, { payload: tagId }) => state.filter(id => id !== tagId);

/**
 * @param {import("modules/global/generic.types").Action<unknown>} action
 * @returns {boolean}
 */
const dealerTagsMatcher = ({ meta = {} }) => meta.source === DASHBOARD_DEALER_SOURCE;

export default createSearchReducers(types.FETCH_TAGS, {
  ids: {
    [LOCATION_CHANGE]: () => [],
    [types.DELETE_TAG_SUCCESS]: afterDeleteTagSuccess,
  },
  global: { matcher: dealerTagsMatcher, paginationSlice: true },
});
